import React from 'react'

function Credit({ photo, className = '' }) {
  return (
    <span className={`credit ${className}`.trim()}>
      Photo:{' '}
      <a href={photo.source} target="_blank" rel="noopener noreferrer">{photo.author}</a>
      {' · '}
      {photo.licenseUrl ? (
        <a href={photo.licenseUrl} target="_blank" rel="noopener noreferrer">{photo.license}</a>
      ) : (
        photo.license
      )}
    </span>
  )
}

export default Credit
